import React from 'react';
import { useIntl } from 'ha/i18n';
import Track from 'ha/components/track/SmartTrack';
import { Link } from '@ha/dsl';

const ForgotPassword: React.FC = () => {
  const { T, urlResolver } = useIntl();

  return (
    <Track name="Clicked Forgot password" type="link">
      <Link
        to={urlResolver.getRecoverAccountUrl()}
        data-test-locator="Forgot password link"
        kind="mint-underline"
      >
        {T('Forgot your password?')}
      </Link>
    </Track>
  );
};

export default ForgotPassword;
